'use client';

import '@ui5/webcomponents/dist/SegmentedButton.js';
import { SegmentedButtonMode } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `SegmentedButton` shows a group of items. When the user clicks or taps one of the items, it stays in a pressed state. It automatically resizes the items to fit proportionally within the component. When no width is set, the component uses the available width.
 *
 * **Note:** There can be just one selected `item` at a time.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-SegmentedButton)
 */
const SegmentedButton = withWebComponent('ui5-segmented-button', ['accessibleName', 'mode'], [], [], ['selection-change']);
SegmentedButton.displayName = 'SegmentedButton';
SegmentedButton.defaultProps = {
  mode: SegmentedButtonMode.SingleSelect
};
export { SegmentedButton };